import React, { useEffect } from 'react';
import Router from './components/Router';
import Modal from 'react-modal';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import theme from './theme';

Modal.setAppElement('#root');

function App() {
  useEffect(() => {
    console.log('---App.componentDidMount()');
  }, []); 

  return (
    <div className="App">
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Router />
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default App;
